import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    token: null,
    userId: null,
    error: null,
    loading: false,
    calendarId: null,
    hasSchedule: null,
    authRedirectPath: '/profile',
    authPath: '/auth',
};

const authStart = ( state, action ) => {
    return updateObject( state, { error: null, loading: true } );
};

const authSuccess = (state, action) => {
    return updateObject( state, { 
        token: action.idToken,
        userId: action.userId,
        calendarId: action.calendarId,
        firstName: action.firstName,
        lastName: action.lastName,
        hasSchedule: action.hasSchedule,
        error: null,
        loading: false
     } );
};

const authFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false
    });
};

const authLogout = (state, action) => {
    return updateObject(state, { token: null, userId: null });
};

const setAuthRedirectPath = (state, action) => {
    return updateObject(state, { authRedirectPath: action.path })
}

const hasScheduleSet = (state, action) => {
    let scheduleHasBeenSet = false;
    let day;
    for (day in action.weekSchedule.days) {
        if (action.weekSchedule.days[day] != null) {
            scheduleHasBeenSet = true;
            break;
        }
    }
    localStorage.setItem('hasSchedule', scheduleHasBeenSet);
    return updateObject(state, { hasSchedule: scheduleHasBeenSet })
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.AUTH_START: return authStart(state, action);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.AUTH_FAIL: return authFail(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        case actionTypes.SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state,action);
        case actionTypes.SETTING_GET: return hasScheduleSet(state, action);
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/auth.js